import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import 'jquery-ui';

import { DefaultGlobalStyles } from '~/AppGlobalStyles';
import {
  PrivateRedirect,
  PrivateRoute,
  useIsAuthenticated,
} from '~/components/Auth';
import { PageNotFound } from '~/components/PageNotFound';
import { SessionMonitor } from '~/components/SessionMonitor';
import { LibraryPackageTestingRouter } from '~/library/LibraryPackageTesting';
import { EmbeddedViewRouter } from '~/scenes/EmbeddedViews';
import { LoginViewRouter } from '~/scenes/LoginViews/router';
import { MobileViews } from '~/scenes/MobileViews';
import { PortalViews } from '~/scenes/PortalViews';
import { EmployeeModuleRouting_Development } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/DevelopmentModule/data';
import { EmployeeModuleRouting_Performance } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/PerformanceModule/data';
import { EmployeeModuleRouting_Rewarding } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/RewardingModule/data';
import { EmployeeModulesOldRouteRedirect } from '~/scenes/PortalViews/Views/EmployeeViews/router';
import { browserLogInfo, cookieEnabledTestFeature } from '~/utils/helper';

import { PortalLinkContext } from './components/PortalLink';
import { EmployeeModuleRouting_People } from './scenes/PortalViews/Views/EmployeeViews/Modules/PeopleModule/data';

export const App: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  // Enable for testing library package components, otherwise keep as "false"
  const isDevelopmentEnvironment = process.env.NODE_ENV === 'development';

  // Debug
  if (cookieEnabledTestFeature('debugEnvironmentVariables')) {
    browserLogInfo('Debug Environment Variables', process.env);
  }

  return (
    <PortalLinkContext.Provider value={{ isRouteLinksEnabled: true }}>
      <DefaultGlobalStyles />
      {isAuthenticated && <SessionMonitor />}
      <Switch>
        <Route path={'/login'} component={LoginViewRouter} />

        <Redirect exact={true} path="/" to="/home" />
        <PrivateRoute path="/mobile" component={MobileViews} />
        <PrivateRoute path="/portal" component={PortalViews} />

        {/*Portal old path redirects*/}
        <PrivateRedirect exact path="/home" to={`portal/home`} />
        <PrivateRedirect
          exact
          path="/my-workspace"
          to={`portal/my-workspace`}
        />
        <PrivateRedirect exact path="/my-team" to={`portal/my-team`} />
        <PrivateRedirect
          exact
          path="/allNotifications"
          to={`portal/all-notifications`}
        />

        {[
          EmployeeModuleRouting_People,
          EmployeeModuleRouting_Rewarding,
          EmployeeModuleRouting_Performance,
          EmployeeModuleRouting_Development,
        ].map(({ path, defaultTab }) => (
          <PrivateRoute path={`/${path}`} key={path}>
            <EmployeeModulesOldRouteRedirect
              modulePath={path}
              defaultTabPath={defaultTab}
            />
          </PrivateRoute>
        ))}

        <PrivateRedirect
          exact
          from={'/admin/workflows'}
          to={'/portal/admin/workflow/workflow2'}
        />
        <PrivateRoute
          path={'/admin'}
          render={({ location: { pathname, search, hash } }) => {
            return <Redirect to={`/portal${pathname}${search}${hash}`} />;
          }}
        />

        <PrivateRoute path="/embedded" component={EmbeddedViewRouter} />

        {isDevelopmentEnvironment && (
          <PrivateRoute
            path="/library-package-test"
            component={LibraryPackageTestingRouter}
          />
        )}

        <Route component={PageNotFound} />
      </Switch>
    </PortalLinkContext.Provider>
  );
};
